export const START_GLOBAL_LOADING = 'cbre-flow-Common/START_GLOBAL_LOADING';
export const STOP_GLOBAL_LOADING = 'cbre-flow-Common/STOP_GLOBAL_LOADING';
